import Vue from 'vue';
import axios from 'axios';
import '../../../filters';
import moment from 'moment';
import { date } from 'devexpress-dashboard/model/index.metadata';


export default {
  name: 'billingStep',
  components: {
    reportsComp: require('../../../common/reports/reports.vue').default,
  },
  props: {
    parent: {
      type: Object,
      required: true
    },
    billingGroupId: {
      type: String,
      required: true
    },
    billingCycleId: {
      type: Number,
      required: true
    },
    stepNo: {
      type: Number,
      required: true
    },
    status: {
      type: Number,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    taskStatus: {
      type: Number,
      required: true
    },
    taskError: {
      type: String,
      required: true
    },
    reports: {
      type: Array,
      required: true
    },
    billingDateFormated: {
      type: String
    },
    billingDate: {
      type: String
    },
  },
  data: function () {
    return {
      stepsTitles: [
        'finaliseMeterReadings',
        'initialiseNewMeterReadingCycle',
        'invoiceForConsumption',
        'produceInstalments',
        'produceTransactionList',
        'createStatements',
      ],
      showAlertDialog: false,
      errorMessage: '',
      showRunConfirmationDialog: false,
      stepTitle: '',
      showReportsDialog: false,
      bd: null,
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  created() {
    this.getImgUrl();
  },
  mounted() {
    
  },
  methods: {
    getImgUrl() {
      return require('../../../assets/images/billing/step' + this.stepNo + ".png")
    },
    getTitle() {
      return this.$t('billing.' + this.stepsTitles[this.stepNo - 1]);
    },
    getStatusImgUrl() {
      if (this.taskStatus == 4 && this.status == 2) {
        return require('../../../assets/images/billing/stepError.png');
      }

      if (this.status == 1)
        return require('../../../assets/images/billing/stepComplete.png');
      else if (this.status == 2)
        return require('../../../assets/images/billing/stepProcessing.gif');
    },
    checkRunBillingStep() {
      if (!this.isOpen) {
        this.errorMessage = this.$t('billing.currentCycleIsAlreadyClosedOrTerminated');
        this.showAlertDialog = true;
        return;
      }
      if (this.status == 1) {
        this.errorMessage = this.$t('billing.billingStepAlreadyCompleted');
        this.showAlertDialog = true;
        return;
      }
      if (this.status == 2) {
        this.errorMessage = this.$t('billing.billingStepCurrentlyInProgress');
        this.showAlertDialog = true;
        return;
      }

      this.stepTitle = this.$t('billing.' + this.stepsTitles[this.stepNo - 1]);
      this.showRunConfirmationDialog = true;
    },
    runBillingStep() {
      var parameters = {
        BillingGroupId: this.billingGroupId,
        Step: this.stepNo,
        ForDate: this.stepNo == 3 ? this.billingDate : null,
      };

      axios.post('/Billing/RunBillingStep', parameters
      )
        .then(response => {
          if (response.status == 200) {
            this.showRunConfirmationDialog = false;
          }
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        });
    },
    getReportsImgUrl() {
      return require('../../../assets/images/billing/reports.png');
    },
    printReport(reportId) {
      var parameters = {
        BillingCycleId: this.billingCycleId,
        ReportId: reportId
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/Billing/CreateReport', parameters),
        response => {
          if (response.status == 200) {
            window.open(response.data, '_blank');
          }
          else
            this.$alertMsg(response.data.data.text)
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );
    },
  },
}
